<template>
    <div class="flex justify-between mt-6 text-sm">
        <router-link :to="prevTo" v-if="prevTo">← {{prevTitle}}</router-link>
        <div v-else></div>
        <router-link :to="nextTo" v-if="nextTo">{{nextTitle}} →</router-link>
        <div v-else></div>
    </div>
</template>
<script>
    import {menu} from "../settings";
    export default {
        name: 'prev-next',
        data(){
            return {
                prevTitle:'',
                nextTitle:'',
                prevTo:'',
                nextTo:'',
            }
        },
        mounted() {
            let current_node_menu = this.$route.path.replace('/','');
            let current_index=menu.findIndex((item)=>{
                return item.path===current_node_menu;
            });

            if(menu[current_index-1]){
                this.prevTo=menu[current_index-1].path;
                this.prevTitle=menu[current_index-1].title;
            }
            if(menu[current_index+1]){
                this.nextTo=menu[current_index+1].path;
                this.nextTitle=menu[current_index+1].title;
            }

            console.log(current_node_menu);
            console.log(current_index);
        }
    }
</script>